import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useStyles } from "../styles";
import { useStepperData } from "../../../Helpers/Contexts/stepperContext";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FileUpload from "../../../Components/FileUpload";
import { useRef, useState } from "react";
import { pdfIcon } from "../../../Assets";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useToast } from "../../../Helpers/Contexts/toastContext";
import { handleFiles } from "../../../Utils/helperFunctions";
import KenLoader from "../../../GlobalComponents/KenLoader";

const qualifications = [
  "Bachelor's Degree",
  "Master's Degree",
  "Diploma",
  "PhD",
  "Certification",
  "Other",
];

const EducationalBackground = () => {
  const classes = useStyles();
  const { showToast } = useToast();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { formData, updateFormData } = useStepperData();
  const [loading, setLoading] = useState(false);

  const handleFileSelect = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    event.preventDefault();
    setLoading(true);
    const data = await handleFiles(event, [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "application/pdf",
    ]);
    if (data?.success) {
      updateFormData(
        "Highest_Qualification_Certification_URL__c",
        data?.message
      );
      setLoading(false);
    } else {
      showToast("error", data?.message);
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <KenLoader />
      ) : (
        <>
          <Typography
            variant="h1"
            className={`${classes.headerTitle} label required`}
            mb={2}
          >
            What’s your educational background?
            {/* <span style={{ color: "#DC5959" }}>*</span> */}
          </Typography>
          <Typography className={classes.headerDescription} mb={4}>
            Select your highest qualification?
          </Typography>
          <FormControl fullWidth sx={{ mb: 3 }}>
            <Typography variant="subtitle2" className="label required" mb={1}>
              Highest qualification
            </Typography>

            <Select
              labelId="Highest_Qualification__c"
              value={formData.Highest_Qualification__c || ""}
              placeholder="Highest Qualification"
              displayEmpty
              sx={{
                color: "#fff",
                ".MuiSelect-icon": {
                  color: "#fff",
                },
                backgroundColor: "#2a2a2a",
              }}
              //   IconComponent={ExpandMoreIcon}
              onChange={(e) =>
                updateFormData("Highest_Qualification__c", e.target.value)
              }
            >
              <MenuItem disabled value="">
                <em>Select</em>
              </MenuItem>

              {qualifications.map((qual) => (
                <MenuItem key={qual} value={qual}>
                  {qual}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {formData.Highest_Qualification__c && (
            <>
              {formData.Highest_Qualification__c === "Other" && (
                <>
                  <Typography
                    variant="subtitle2"
                    className="label required"
                    mb={1}
                  >
                    Add your highest qualification
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="Enter your highest qualification"
                    value={formData.Highest_Qualification_Other__c || ""}
                    onChange={(e) =>
                      updateFormData(
                        "Highest_Qualification_Other__c",
                        e.target.value
                      )
                    }
                  />
                </>
              )}
              <Box
                sx={{
                  mb: 2,
                }}
              >
                {formData?.Highest_Qualification_Certification_URL__c ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 2,
                      background: "#161616",
                      padding: "12px 16px",
                      borderRadius: "8px",
                      marginBottom: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: "12px",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={pdfIcon}
                        alt="Document Icon"
                        style={{ width: "24px", height: "24px" }}
                      />
                      <Box>
                        <Typography variant="body1" color="white">
                          document
                        </Typography>
                        <Typography variant="body1" color={"success.main"}>
                          Uploaded
                        </Typography>
                      </Box>
                    </Box>
                    <Button
                      onClick={() =>
                        updateFormData(
                          "Highest_Qualification_Certification_URL__c",
                          ""
                        )
                      }
                    >
                      <DeleteOutlineIcon
                        style={{ color: "white", fontSize: "24px" }}
                      />
                    </Button>
                  </Box>
                ) : (
                  <FileUpload
                    onImageSelect={handleFileSelect}
                    acceptedFileTypes="image/*,application/pdf"
                    fileInputRef={fileInputRef}
                  />
                )}
              </Box>
            </>
          )}
          <Typography variant="subtitle2" mb={1} className="label required">
            Institute name
          </Typography>
          <TextField
            fullWidth
            placeholder="Name of Institution"
            value={formData.Institute_Name__c || ""}
            onChange={(e) =>
              updateFormData("Institute_Name__c", e.target.value)
            }
          />
        </>
      )}
    </>
  );
};

export default EducationalBackground;
